import { STATUS } from "../helper";
import XLSX from 'xlsx-js-style';


const withColor = (curr: any[]) => curr.map((value) => 
    ({
        v: value,
        s: {
            fill: {
                patternType: 'solid',
                fgColor: { rgb: 'FF3C00' },
                bgColor: { rgb: 'FF3C00' },
            }
        }
    }))

const withoutColor = (curr: any[]) => curr.map((value) => ({ v: value }));

export const downloadCertificates = (headers: string[], certificates: any[], filename: string) => {
    const data = (certificates as any).reduce((acc: any, curr: any) => {
        if (curr.status === STATUS.NOT_FOUND.toString()) {
            return [...acc, [...withColor(Object.values(curr))]] 
        }
        return [...acc, [...withoutColor(Object.values(curr))]] 
    }, []);


    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
    let wscols: any[] = [];

    Object.keys(headers).map((c) => {
        wscols.push({wch: 20});
    })

    worksheet["!cols"] = wscols as any;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Diplômes");
    XLSX.writeFile(workbook, `${filename}.xlsx`, { compression: true });
}